import React from "react";

const PluginActionForm = () => {
  return <div />;
};

export default PluginActionForm;
